import React from 'react';
import cx from 'classnames';
import usePagination from '@mui/material/usePagination/usePagination';
import css from './PaginationTemplate.module.scss';
import { setFilters } from '../../store/reducers/filtersSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { ReactComponent as ArrowRightIcon } from './images/arrow-right.svg';

export const PaginationTemplate = () => {
  const dispatch = useAppDispatch();
  const { payment } = useAppSelector((state) => state.paymentsReducer);
  const { filters } = useAppSelector(state => state.filtersReducer);
  const { items } = usePagination({
    page: filters?.page && filters?.page - 1,
    count: payment?.pagination?.totalPages,
  });
  
  if (payment?.pagination === null || payment?.pagination?.totalPages! <= 1) {
    return null;
  }
  return (
    <nav>
      <ul className={css.list}>
        {items.map(({ page, type, selected, onClick, ...item }, index) => {
          let children = null;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = '…';
          } else if (type === 'page') {
            children = (
              <button
                onClick={(value) => {
                  onClick(value); 
                  page !== filters?.page && page && dispatch(setFilters({...filters, page }));
                }}
                type="button"
                className={cx(css.item, page === filters?.page && css.selected)}
                {...item}
              >
                {page}
              </button>
            );
          } else {
            children = (
              <button
                {...item}
                className={css.navigation}
                type="button"
                onClick={(value) => {
                  filters?.page && dispatch(setFilters({...filters, page: type === 'previous' ? filters?.page - 1 : filters?.page + 1 }));
                  onClick(value);
                }}
                disabled={type === 'previous' ? (filters?.page === 1) : filters?.page === payment?.pagination?.totalPages}
              >
                {type === 'previous' ? <ArrowRightIcon className={css.left} /> : <ArrowRightIcon />}
              </button>
            );
          }

          return <li className={css[type]} key={index}>{children}</li>;
        })}
      </ul>
    </nav>
  );
};